import {
  ProductionOrderItem,
  ProductionOrderRequestFormState,
  RESPONSIBILITY_ROW_COUNT,
} from './types'

const emptyFactory = () => ({ enabled: false, percent: '' })

export const createEmptyProductionOrderItem = (): ProductionOrderItem => ({
  id: `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`,
  no: '',
  item: '',
  quantity: '',
  pricePerQ: '',
  pilePerUnit: '',
  drivingPerUnit: '',
  other: '',
  pileAndDrivingPerUnit: '',
})

export const createInitialProductionOrderItems = (count = 5): ProductionOrderItem[] =>
  Array.from({ length: count }, () => createEmptyProductionOrderItem())

export const INITIAL_PRODUCTION_ORDER_REQUEST: ProductionOrderRequestFormState = {
  specialPillarEnabled: false,
  specialPillarDate: null,
  specialStopEnabled: false,
  specialStopCount1: '',
  specialStopCount2: '',
  specialOtherEnabled: false,
  specialOtherDetail: '',
  items: createInitialProductionOrderItems(),
  productionFactories: {
    factory1: emptyFactory(),
    factory2: emptyFactory(),
    factory3: emptyFactory(),
    joint: emptyFactory(),
  },
  productionCompany: '',
  documents: {
    soil: false,
    site: false,
    contract: false,
    cert: false,
    vat: false,
    other: false,
    otherDetail: '',
  },
  customerGrade: '',
  depositPercent: '',
  depositAmount: '',
  financeNote: '',
  responsibility: Array.from({ length: RESPONSIBILITY_ROW_COUNT }, (_, rowIndex) => ({
    rowIndex,
    owner: null,
  })),
}
